<template>
    <div class="row mb-5">
        <section-headline :edit="isEditing"
                          :hasEdit="true"
                          msg="Meine Infos"
                          @click="payload => this.isEditing = payload"></section-headline>

        <loader v-if="isFetching"></loader>

        <transition-group v-else class="col-12" mode="in-out" name="slide" tag="div">
            <div v-if="!isFetching && !isEditing"
                 :key="1"
                 class="row col-12">
                <!--                 image -->
                <div class=" col-12 col-lg-4 mb-4 mb-lg-0 ">
                    <img class="image rounded-lg w-100" :src="imagePath" alt="Markt Foto">

                    <img class="image rounded-lg w-100 mt-4 d-block" :src="portraitPath" alt="Markt Foto">
                </div>

                <!--                contact -->
                <div class="contact col-12 col-md-6 col-lg-4 mb-3">
                    <div class="d-flex flex-column">
                        <block-headline icon="id-badge" text="Kontakt"></block-headline>
                        <ul class="list-group list-group-flush">
                            <opening-list-item v-if="element.address[0].zip && element.address[0].city"
                                               :text="element.address[0].zip + ' ' + element.address[0].city"
                                               icon="fa-globe"></opening-list-item>
                            <opening-list-item v-if="element.address[0].street"
                                               :text="element.address[0].street"
                                               icon="fa-map-marker-alt"></opening-list-item>
                            <opening-list-item v-if="element.contact[0].phone"
                                               :text="element.contact[0].phone"
                                               icon="fa-phone"></opening-list-item>
                            <opening-list-item v-if="element.contact[0].fax"
                                               :text="element.contact[0].fax"
                                               icon="fa-fax"></opening-list-item>
                            <opening-list-item v-if="element.contact[0].email"
                                               :text="element.contact[0].email"
                                               icon="fa-envelope"></opening-list-item>
                            <opening-list-item v-if="element.contact[0].website"
                                               :text="element.contact[0].website"
                                               icon="fa-browser"></opening-list-item>
                        </ul>
                    </div>
                </div>

                <!--                time -->
                <div class="time col-12 col-md-6 col-lg-4 mb-3">
                    <block-headline icon="clock" text="Öffnungszeiten"></block-headline>
                    <ul class="list-group list-group-flush">
                        <li v-for="(hour, index) in 7"
                            :key="index"
                            class="list-group-item">
                            <div class="form-group d-flex justify-content-between align-items-center m-0">
                                <div class="m-0 min-width">
                                    <p class="m-0">{{ displayWeekday(index + 1) }}</p>
                                </div>
                                <div class="w-100 ml-3">
                                    <p class="m-0 text-right d-flex flex-column"
                                       v-html="displayOpening(element.openings[0][index + 1])"></p>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <hr/>

                    <template v-if="element.hybrid_market.value">
                        <block-headline icon="shopping-bag" text="Hybridmarkt Öffnungszeiten" class="whitespace-nowrap"></block-headline>

                        <ul class="list-group list-group-flush">
                            <li v-for="(hour, index) in 7"
                                :key="index"
                                class="list-group-item"
                                v-show="element.hybrid_openings[0][index + 1]"
                            >
                                <div class="form-group d-flex justify-content-between align-items-center m-0" v-if="element.hybrid_openings[0][index + 1]">
                                    <div class="m-0 min-width">
                                        <p class="m-0">{{ displayWeekday(index + 1) }}</p>
                                    </div>
                                    <div class="w-100 ml-3">
                                        <p class="m-0 text-right d-flex flex-column"
                                           v-html="displayOpening(element.hybrid_openings[0][index + 1])"></p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <h4 v-else>
                        <block-headline icon="shopping-bag" text="Kein Hybridmarkt"></block-headline>
                    </h4>
                </div>
            </div>

            <div v-if="!isFetching && isEditing"
                 :key="2">
                <FormulateForm
                    v-model="element"
                    :keep-model-data="true"
                    :errors="inputErrors"
                    class="mb-5 col-12"
                    @submit="submitForm">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <block-headline class="col-12" icon="map-marker-alt" text="Standort"></block-headline>
                                <FormulateInput
                                    :aspectRatio="4/3"
                                    class="col-12"
                                    help='Das Profilbild wird auf allen Endgeräten nahezu quadratisch angezeigt. Wenn Sie ein Bild hochladen, sehen Sie den erwarteten Ausschnitt als Markierung - bitte positionieren Sie den gewünschten Ausschnitt innerhalb der Markierung und klicken Sie auf "Speichern".'
                                    label="Bild"
                                    name="media"
                                    type="cropper"
                                    upload-behavior="delayed"
                                    validation-name="Bild"/>

                                <FormulateInput
                                    class="col-12"
                                    help='Freigestelltes Foto'
                                    label="Portrait"
                                    name="portrait"
                                    type="file"
                                    upload-behavior="delayed"
                                    validation-name="Portrait"
                                />

                                <FormulateInput
                                    :address="element.address[0]"
                                    :prevent-deregister="true"
                                    :settings="gmap.settings"
                                    :visual="gmap.visual"
                                    class="col-12"
                                    label="Google Maps Standort"
                                    name="map"
                                    type="map"
                                    validation="optional"
                                    validation-name="Google Maps Standort"/>

                                <form-buttons :isLoading="isSubmitting"
                                              @cancel="cancelEdit"></form-buttons>
                            </div>
                        </div>

                        <hr class="w-100">

                        <!--                        Kontakt -->
                        <div class="col-12">
                            <div class="row">
                                <block-headline class="col-12" icon="id-badge" text="Kontakt"></block-headline>

                                <FormulateInput
                                    class="col-12"
                                    label="Adressangaben"
                                    name="address"
                                    type="group">
                                    <div class="row">
                                        <FormulateInput
                                            class="col-6"
                                            label="Postleitzahl"
                                            name="zip"
                                            placeholder="Postleitzahl"
                                            validation="required"
                                            type="text"
                                            validation-name="Postleitzahl"/>

                                        <FormulateInput
                                            class="col-6"
                                            label="Stadt"
                                            name="city"
                                            placeholder="Stadt"
                                            type="text"
                                            validation="required"
                                            validation-name="Stadt"/>

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Adresse"
                                            name="street"
                                            placeholder="Adresse"
                                            type="text"
                                            validation="required"
                                            validation-name="Adresse"/>

                                        <FormulateInput
                                            :options="this.stateOptions"
                                            class="col-12 col-md-6"
                                            label="Bundesland"
                                            name="state"
                                            placeholder="Bundesland"
                                            type="multiselect"
                                            validation="required"
                                            validation-name="Bundesland"/>
                                    </div>
                                </FormulateInput>

                                <FormulateInput
                                    class="col-12"
                                    label="Kontakt Informationen"
                                    name="contact"
                                    type="group">

                                    <div class="row">
                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Marktname"
                                            name="name"
                                            placeholder="Marktname"
                                            type="tel"
                                            validation="required"
                                            validation-name="Marktname"/>

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Telefonnummer"
                                            name="phone"
                                            placeholder="Telefonnummer"
                                            type="tel"
                                            validation="optional"
                                            validation-name="Telefonnummer"/>

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Fax"
                                            name="fax"
                                            placeholder="Fax"
                                            type="tel"
                                            validation="optional"
                                            validation-name="Fax"/>

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="E-Mail Adresse"
                                            name="email"
                                            placeholder="E-Mail Adresse"
                                            type="email"
                                            validation="optional|^email"
                                            validation-name="E-Mail Adresse"/>

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Website"
                                            name="website"
                                            placeholder="Website"
                                            type="url"
                                            help="Eine valide URL beginnt mit http:// oder https://"
                                            validation="optional|^url"
                                            validation-name="Website"/>
                                    </div>
                                </FormulateInput>

                                <form-buttons :isLoading="isSubmitting"
                                              @cancel="cancelEdit"></form-buttons>
                            </div>
                        </div>

                        <hr class="w-100">
                        <!--                    Hours -->
                        <div class="col-12 mb-3">
                            <div class="row">
                                <block-headline class="col-12" icon="clock" text="Öffnungszeiten"></block-headline>

                                <FormulateInput
                                    class="col-12"
                                    name="openings"
                                    type="group">

                                    <div id="accordion">
                                        <div v-for="(opening , index) in 7"
                                             :key="index + 1"
                                             class="card">
                                            <div :id="'accordion__heading-' + index + 1"
                                                 class="card-header p-0">
                                                <div
                                                    :class="index + 1 === 1 ? '': 'collapsed'"
                                                    :data-target="'#collapse-' + index + 1"
                                                    class="mb-0 row no-gutters p-3 col-12 justify-content-between heading__wrapper"
                                                    data-toggle="collapse">
                                                    <p class="mr-1 mb-0">
                                                        <b>{{ displayWeekday(index + 1) }}</b>
                                                    </p>
                                                    <div class="row no-gutters">
                                                        <p v-for="hour in element.openings[0][index + 1]"
                                                           v-if="Object.keys(element.openings[0][index + 1]).length !== 0"
                                                           class="mr-1 mb-0 accordion__headline">
                                                            {{ hour.start }} : {{ hour.end }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div :id="'collapse-' + index + 1"
                                                 :class="index + 1 === 1 ? 'show' : ''"
                                                 class="collapsed collapse"
                                                 data-parent="#accordion">
                                                <div class="card-body">
                                                    <FormulateInput
                                                        :name="String(index + 1)"
                                                        :repeatable="true"
                                                        :value="[]"
                                                        add-label="+ Zeiten"
                                                        type="group">

                                                        <div class="weekday row">
                                                            <FormulateInput
                                                                class="col-6 mb-0"
                                                                label="Öffnung"
                                                                name="start"
                                                                type="time"
                                                                validation="required"
                                                                validation-name="Öffnungszeit"/>
                                                            <FormulateInput
                                                                class="col-6 mb-0"
                                                                label="Schließung"
                                                                name="end"
                                                                type="time"
                                                                validation="required"
                                                                validation-name="Schließungszeit"/>
                                                        </div>
                                                    </FormulateInput>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormulateInput>

                                <form-buttons :isLoading="isSubmitting"
                                              @cancel="cancelEdit"></form-buttons>
                            </div>
                        </div>

                        <hr class="w-100">
                        <!--                    Hybrid market -->
                        <div class="col-12 mb-3">
                            <div class="row">
                                <block-headline class="col-12" icon="clock" text="Hybridmarkt"></block-headline>

                                <FormulateInput
                                    :options="[{'name': 'Ja','value': 1},{'name': 'Nein','value': 0}]"
                                    class="col-6"
                                    label="Hybridmarkt"
                                    name="hybrid_market"
                                    placeholder="Hybridmarkt"
                                    type="multiselect"
                                    validation="required"
                                    validation-name="Hybridmarkt"/>

                                <FormulateInput
                                    class="col-12"
                                    name="hybrid_openings"
                                    type="group">

                                    <div id="accordion">
                                        <div v-for="(opening , index) in 7"
                                             :key="index + 1"
                                             class="card">
                                            <div :id="'accordion__heading-' + index + 1"
                                                 class="card-header p-0">
                                                <div
                                                    :class="index + 1 === 1 ? '': 'collapsed'"
                                                    :data-target="'#collapse-' + index + 1"
                                                    class="mb-0 row no-gutters p-3 col-12 justify-content-between heading__wrapper"
                                                    data-toggle="collapse">
                                                    <p class="mr-1 mb-0">
                                                        <b>{{ displayWeekday(index + 1) }}</b>
                                                    </p>
                                                    <div class="row no-gutters">
                                                        <p v-for="hour in element.hybrid_openings[0][index + 1]"
                                                           v-if="Object.keys(element.hybrid_openings[0][index + 1]).length !== 0"
                                                           class="mr-1 mb-0 accordion__headline">
                                                            {{ hour.start }} : {{ hour.end }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div :id="'collapse-' + index + 1"
                                                 :class="index + 1 === 1 ? 'show' : ''"
                                                 class="collapsed collapse"
                                                 data-parent="#accordion">
                                                <div class="card-body">
                                                    <FormulateInput
                                                        :name="String(index + 1)"
                                                        :repeatable="true"
                                                        :value="[]"
                                                        add-label="+ Zeiten"
                                                        type="group">

                                                        <div class="weekday row">
                                                            <FormulateInput
                                                                class="col-6 mb-0"
                                                                label="Öffnung"
                                                                name="start"
                                                                type="time"
                                                                validation="required"
                                                                validation-name="Öffnungszeit"/>
                                                            <FormulateInput
                                                                class="col-6 mb-0"
                                                                label="Schließung"
                                                                name="end"
                                                                type="time"
                                                                validation="required"
                                                                validation-name="Schließungszeit"/>
                                                        </div>
                                                    </FormulateInput>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormulateInput>

                                <form-buttons :isLoading="isSubmitting"
                                              @cancel="cancelEdit"></form-buttons>
                            </div>
                        </div>

                        <hr class="w-100">

                        <div v-if="userRole !== 'merchant'" class="col-12 mb-3">
                            <div class="row">
                                <block-headline class="col-12" icon="cog" text="Einstellungen"></block-headline>
                                <div class="col-12">
                                    <div class="alert alert-success" role="alert">
                                        Diese Einstellungen sind nur für GHH Mitarbeiter und Administratoren sichtbar!
                                    </div>
                                </div>
                                <FormulateInput
                                    class="col-12"
                                    name="settings"
                                    type="group">

                                    <div class="row">
                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Mitarbeiteranzahl"
                                            name="employees"
                                            step="1"
                                            type="number"/>

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Zuständiger Verkaufsberater"
                                            name="sales_advisor"
                                            type="text"/>

                                        <FormulateInput
                                            :options="[{'name': 'Ja','value': 1},{'name': 'Nein','value': 0}]"
                                            class="col-12 col-md-6"
                                            label="Werbenutzung über 50%"
                                            name="advertising_usage"
                                            type="multiselect"
                                            :value="{'name': 'Nein','value': 0}"
                                            placeholder="Bitte auswählen"
                                            validation="required"/>

                                        <FormulateInput
                                            :options="[{'name': 'Ja','value': 1},{'name': 'Nein','value': 0}]"
                                            class="col-12 col-md-6"
                                            label="Werbescreen"
                                            name="advertising_screen"
                                            type="multiselect"
                                            :value="{'name': 'Nein','value': 0}"
                                            placeholder="Bitte auswählen"
                                            validation="required"/>

                                        <FormulateInput
                                            class="col-6"
                                            label="Kühlmöbelanzahl"
                                            name="refrigerated_displays"
                                            step="0.01"
                                            type="number"/>

                                        <FormulateInput
                                            class="col-6"
                                            label="Kühlmöbellaufmeter"
                                            name="refrigerated_displays_length"
                                            step="0.01"
                                            type="number"/>

                                        <FormulateInput
                                            class="col-6"
                                            label="Eröffnungsdatum"
                                            name="opening_date"
                                            type="date"/>

                                        <FormulateInput
                                            class="col-6"
                                            label="Schließungsdatum"
                                            name="closing_date"
                                            type="date"/>

<!--                                        <FormulateInput-->
<!--                                            :options="fullWholesalerOptions"-->
<!--                                            class="col-12 col-md-6"-->
<!--                                            label="Flugblatt vom Großhandelshaus"-->
<!--                                            name="wholesaler_leaflet"-->
<!--                                            placeholder="Flugblatt vom Großhandelshaus"-->
<!--                                            type="multiselect"-->
<!--                                            validation="required"-->
<!--                                            validation-name="Flugblatt vom Großhandelshaus"/>-->

                                        <FormulateInput
                                            class="col-12 col-md-6"
                                            label="Anzahl Trainings"
                                            name="number_trainings"
                                            step="1"
                                            placeholder="Anzahl Trainings"
                                            type="number"/>

                                    </div>
                                </FormulateInput>
                            </div>
                        </div>
                    </div>
                    <form-buttons :isLoading="isSubmitting"
                                  @cancel="cancelEdit"></form-buttons>
                </FormulateForm>
            </div>
        </transition-group>
    </div>
</template>

<script>
import OpeningListItem from './OpeningListItem';
import FileUpload from '@braid/vue-formulate/src/FileUpload';

export default {
    name: 'MerchantDetail',
    components: {
        OpeningListItem,
    },
    data() {
        return {
            isEditing: false,
            schema: Array,
            isFetching: true,
            isSubmitting: false,
            element: {},
            stateOptions: null,
            wholesalerOptions: null,
            gmap: {
                settings: {
                    options: {
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUi: false,
                    },
                    location: null,
                },
                visual: {
                    height: '300',
                    zoom: 15,
                    mapTypeId: 'roadmap',
                },
            },
            inputErrors: null,
            userRole: null,
        };
    },

    async created() {
        this.userRole = auth.user.type;
        await this.fetchData();
        this.isFetching = false;
    },

    methods: {
        fetchData() {
            const merchant = axios.get('/api/admin/merchant');
            const state = axios.get('/api/admin/states');
            const wholesaler = axios.get('/api/admin/wholesalers');

            return axios.all([merchant, state, wholesaler]).then((responses) => {
                this.element = responses[0].data.data;
                this.gmap.settings.location = responses[0].data.data.map;
                this.stateOptions = responses[1].data;
                this.wholesalerOptions = responses[2].data;
            }).catch((errors) => {
                this.$swal({
                    icon: 'error',
                    title: 'Die Daten konnten nicht geladen werden',
                });
            });
        },

        cancelEdit() {
            this.isEditing = false;
            this.fetchData();
        },

        displayWeekday(day) {
            if (day) {
                return moment().day(day).format('dd');
            }
        },

        displayOpening(hours) {
            let displayString = '';

            if (hours === undefined) {
                displayString = 'Geschlossen';
            }

            if (hours !== undefined) {
                hours.forEach((element, index) => {
                    displayString += '<span class="whitespace-nowrap">' + element.start + ' : ' + element.end +
                        '</span>';
                });
            }
            return displayString;
        },

        submitForm(formData) {
            this.isSubmitting = true;
          console.log(formData);

            axios({
                method: 'patch',
                url: '/api/admin/merchant/' + this.element.id,
                data: formData,
            }).then((response) => {
                this.element = response.data.validated;
                this.gmap.settings.location = response.data.validated.map;
                this.$swal({
                    title: response.data.message,
                });
                this.cancelEdit();
                this.isSubmitting = false;
            }).catch((error) => {
                this.inputErrors = error.response.data.errors;
                this.$swal({
                    icon: 'error',
                    title: 'Es ist ein Fehler aufgetreten',
                });
                this.isSubmitting = false;
            });
        },
    },

    computed: {
        fullWholesalerOptions() {
            let options = [{name: 'Kein Großhandelshaus Flugblatt', value: null}];
            this.wholesalerOptions.forEach((option) => {
                options.push({name: option.name, value: option.id});
            });
            return options;
        },

        imagePath() {
            let media = this.element?.media;

            if (media && media.length > 0) {
                return media[0].url;
            }

            if (media && media instanceof FileUpload && media.files.length > 0) {
                let url = media.files[0].path.url;

                if (!url.startsWith('/tmp')) {
                    return url;
                }
            }

            return '/images/placeholder.png';
        },
        portraitPath() {
            let portrait = this.element?.portrait;

            if (portrait && portrait.length > 0) {
                return portrait[0].url;
            }

            if (portrait && portrait instanceof FileUpload && portrait.files.length > 0) {
                let url = portrait.files[0].path.url;

                if (!url.startsWith('/tmp')) {
                    return url;
                }
            }

            return '/images/placeholder.png';
        },
    },
};
</script>
